import styled, { css } from 'styled-components/macro'
import { transparentize } from 'polished'

export const Wrapper = styled.div`
  position: relative;
  margin: 0 0 4.8rem;
  display: flex;
  flex-direction: column;
  width: 100%;
  text-align: left;
  gap: 0.6rem;
`

export const Label = styled.label`
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  font-weight: ${(props) => props.theme.font.weight.regular};
  font-size: 1.4rem;
  line-height: 1.5;
  color: ${(props) => props.theme.color.textThird};
`

export const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`

export const IconWrap = styled.div`
  position: absolute;
  left: 1.2rem;
  width: 2rem;
  height: 2rem;
`

export const SearchIcon = styled.div`
  width: 2rem;
  height: 2rem;
  color: ${(props) => props.theme.color.textThird};
`

export const Search = styled.input<{ error: boolean }>`
  position: relative;
  margin: 0;
  padding: 1rem 1.6rem 1rem 4.2rem;
  display: block;
  width: 100%;
  font-family: ${(props) => props.theme.font.family.default};
  font-weight: ${(props) => props.theme.font.weight.regular};
  font-size: 1.6rem;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: left;
  color: ${(props) => props.theme.color.text};
  background-color: ${(props) => transparentize(0.96, props.theme.color.text)};
  border: 0.1rem solid ${(props) => props.theme.color.inputColor};
  border-radius: 0.8rem;
  box-shadow: none;
  transition: color 0.26s ease, box-shadow 0.26s ease;
  &::placeholder {
    font-family: ${(props) => props.theme.font.family.default};
    font-weight: ${(props) => props.theme.font.weight.regular};
    font-size: 1.6rem;
    line-height: 1.25;
    letter-spacing: normal;
    color: ${(props) => props.theme.color.textThird};
    opacity: ${(props) => props.theme.opacity.default};
    transform-origin: left center;
  }
  &:hover,
  &:focus {
    -moz-appearance: number-input;
  }
  &:disabled {
    opacity: ${(props) => props.theme.opacity.opacity05};
  }
  &[readonly] {
    cursor: no-drop;
    opacity: ${(props) => props.theme.opacity.opacity05};
  }

  -moz-appearance: textfield;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &:hover:not([disabled]) {
    box-shadow: 0 0 0 0.3rem ${(props) => transparentize(0.7, props.theme.color.inputColor)};
  }
  &:focus:not([disabled]) {
    caret-color: ${(props) => props.theme.color.black};
    box-shadow: 0 0 0 0.3rem ${(props) => transparentize(0.7, props.theme.color.inputColor)};
    outline: none;
  }
  &:active:not([disabled]) {
    box-shadow: 0 0 0 0.3rem ${(props) => transparentize(0.7, props.theme.color.inputColor)};
  }

  ${(props) =>
    props.error &&
    css`
      border-color: ${(props) => props.theme.color.danger};
    `}
`

export const ErrorMessage = styled.span`
  position: absolute;
  top: calc(100% + 0.2rem);
  left: 0;
  padding: 0.3rem 1.6rem;
  font-size: 1.2rem;
  line-height: 1.67;
  color: ${(props) => props.theme.color.danger};
  z-index: ${(props) => props.theme.zIndex.minimal};
`
